import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { ConfirmActionPopup } from '../../PopUps';
import { EventAttachmentMediaTypes } from '../../../utils/eventConstants';
import { fetchEventAttachments, deleteEventAttachment } from '../../../actions/event-actions';

const Attachments = (props) => {
    const {
        getEventAttachments,
        removeEventAttachment,
        events,
    } = props;

    const { attachments } = events.currentEvent;
    const [downloadLink, setDownloadLink] = useState(null);
    const [showDeleteConfirmPopup, setShowDeleteConfirmPopup] = useState(false);
    const [toDeleteAttachment, setToDeleteAttachment] = useState(null);

    useEffect(() => {
        getEventAttachments(events.currentEvent.data.id);
    }, [events.currentEvent.data.id]);

    const handleAttachmentClick = (attachment) => {
        if (attachment.attachmentMediaType === EventAttachmentMediaTypes.LINK) {
            const win = window.open(attachment.srcUrl, '_blank');
            win.focus();
        } else if (downloadLink) {
            downloadLink.href = `/api/v1/tms/events/${events.currentEvent.data.id}/file/${attachment.fileId}`;
            downloadLink.click();
        }
    };

    const handleDeleteAttachmentClick = (attachment) => {
        setToDeleteAttachment(attachment);
        setShowDeleteConfirmPopup(true);
    };

    const deleteAttachment = () => {
        removeEventAttachment(events.currentEvent.data.id, toDeleteAttachment.fileId);
        setToDeleteAttachment(null);
        setShowDeleteConfirmPopup(false);
    };

    return (
        <>
            {attachments && Array.isArray(attachments) && attachments.length > 0 && (
                <div
                    data-test="attachments"
                    className="attachments-wrapper"
                >
                    <a ref={(el) => { setDownloadLink(el); }} className="d-none" target="_blank" />
                    {attachments.map((attachment) => {
                        return (
                            <div
                                key={`attachment-${attachment.fileId}`}
                                className="mt20"
                            >
                                <span
                                    data-test={`attachment-${attachment.fileId}`}
                                    className="cursor-pointer btn btn-primary"
                                    onClick={() => handleAttachmentClick(attachment)}
                                >
                                    {attachment.attachmentMediaType === EventAttachmentMediaTypes.LINK ? 'View' : 'Download'} {attachment.title}
                                </span>
                                {attachment.actions && attachment.actions.delete && attachment.actions.delete.allowed && (
                                    <span
                                        data-test={`attachment-${attachment.fileId}-delete`}
                                        className="ml16 cursor-pointer text-danger text-small"
                                        onClick={() => handleDeleteAttachmentClick(attachment)}
                                    >
                                        Delete
                                    </span>
                                )}
                            </div>
                        );
                    })}
                </div>
            )}
            {showDeleteConfirmPopup && (
                <ConfirmActionPopup
                    onCloseClick={() => {
                        setShowDeleteConfirmPopup(false);
                    }}
                    onCtaClick={deleteAttachment}
                    confirmationTitle="Delete Attachment"
                    confirmationMessage="Delete attachment?"
                    data-testid="modal.delete-attachment"
                />
            )}
        </>
    );
};

function mapStateToProps({ events }) {
    return { events };
}

function mapDispatchToProps(dispatch) {
    return {
        getEventAttachments: (eventId) => dispatch(fetchEventAttachments(eventId)),
        removeEventAttachment: (eventId, fileId) => dispatch(deleteEventAttachment(eventId, fileId)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Attachments);
